const AlertTemplateFields = [
  {
    id: Math.random() * 10,
    name: "Alert_Template",
    fields: [
      {
        id: Math.random() * 10,
        name: "Template_Name",
        label: "Template Name",
        type: "text",
      },
      {
        id: Math.random() * 10,
        name: "Template_Type",
        label: "Template Type",
        type: "inputdrop",
        dropdowncontent: ["SMS", "Email", "Notification"],
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Template_Code",
        label: "Template Code",
        type: "text",
      },
      {
        id: Math.random() * 10,
        name: "Template",
        label: "Template",
        type: "textarea",
      },
      {
        id: Math.random() * 10,
        name: "Description",
        label: "Description",
        type: "text",
      },
      {
        id: Math.random() * 10,
        name: "From_Mail",
        label: "From Mail",
        type: "text",
      },
      {
        id: Math.random() * 10,
        name: "Password",
        label: "Password",
        type: "text",
      },
      {
        id: Math.random() * 10,
        name: "Subject",
        label: "Subject",
        type: "text",
      },
      {
        id: Math.random() * 10,
        name: "Notification_Route",
        label: "Notification Route",
        type: "text",
      },
    ],
  },
];

export { AlertTemplateFields };
